// extracted by mini-css-extract-plugin
export var article_title = "genericHero-module--article_title--e627e";
export var bg_Img = "genericHero-module--bg_Img--5a191";
export var black = "genericHero-module--black--cb9d5";
export var cat_title = "genericHero-module--cat_title--556a9";
export var container = "genericHero-module--container--f6950";
export var desc = "genericHero-module--desc--6883a";
export var desktopImage = "genericHero-module--desktop-image--0a790";
export var heroImage = "genericHero-module--hero-image--967a9";
export var hero_container = "genericHero-module--hero_container--53e91";
export var icon = "genericHero-module--icon--d0d80";
export var mobileImage = "genericHero-module--mobile-image--326b7";
export var purposePage = "genericHero-module--purpose-page--8271e";
export var seoHeading = "genericHero-module--seo-heading--58642";
export var shortDescription = "genericHero-module--shortDescription--b3fdc";
export var socialIcons = "genericHero-module--social-icons--dadd6";
export var subHeading = "genericHero-module--sub-heading--94bc1";
export var text_container = "genericHero-module--text_container--9150c";